/**
 * Parses GraphQL mutation result data into a tuple of [payload, rejection]
 * @param result - The GraphQL result data
 * @param payloadTypename - The __typename of the success payload
 * @param rejectionTypename - The __typename of the rejection payload
 */
export function parseGraphqlResult(result, payloadTypename, rejectionTypename) {
    if (!result)
        return [null, null];
    // eslint-disable-next-line no-underscore-dangle
    switch (result.__typename) {
        case payloadTypename:
            return [result, null];
        case rejectionTypename:
            return [null, result];
        default:
            return [null, null];
    }
}
